<template>
    <ActionSheet v-model="show" @close="closeSheet">
        <div class="sku">
            <div class="sku_header van-hairline--bottom" v-if="SkuInfo">
                <VanImage :src="SkuInfo.imgurl[0]" alt="" lazy-load width="1.92rem" height="1.92rem" fit="contain"/>
                <div class="sku_header_info">
                    <span class="sku_header_price">
                        <img :src="require('assets/img/common/coin.png')" class="coin" alt="">
                        <span class="price_num">{{SkuInfo.sellingpoints}}</span>
                        <template v-if="SkuInfo.sellingprice*1>0">
                            <span  class="price-symbol"> + </span><span class="price-symbol">¥</span> <span class="price_num">{{SkuInfo.sellingprice}}</span>
                        </template>
                    </span>
                    <span>剩余: {{inventory.stock}}</span>
                    <span>选择: {{inventory.property}}</span>
                </div>
            </div>
            <div class="sku_body">
               <div class="sku_group van-hairline--bottom">
                   <div class="sku_title">请选择规格:</div>
                   <Tag  size="large"   :text-color="inventory.id==item.id?'#f44':'#323233'" :color="inventory.id==item.id?'rgba(244,79,68,.11)':'#F6F8FA'" v-for="item in SkuInfo.inventory"  @click="selectSku(item)">
                       {{item.property}}
                   </Tag>
               </div>
                <div class="sku_stepper van-hairline--bottom">
                    <span>购买数量:</span>
                    <Stepper v-model="inventory.amount" integer :max="inventory.limit" />
                </div>
            </div>
            <GoodsActionButton color="linear-gradient(to right, #2F7BE8, #82BBFD)" type="danger" @click="preSubmit">下一步</GoodsActionButton>

        </div>
    </ActionSheet>
</template>
<script>
    import "./index.less"
    import {ActionSheet, Image,Tag,Stepper,GoodsActionButton} from 'vant'

    export default {
        name: "sku",
        components: {
            ActionSheet,
            VanImage: Image,
            Tag,
            Stepper,
            GoodsActionButton
        },
        watch: {
            skushow(e) {
                this.show = e
            },
            SkuInfo(e){
                if(e.inventory.length==1){
                    let {id,stock,limit,property} = e.inventory[0];
                    Object.assign(this.inventory,{id,stock,limit,property})
                }
            }
        },
        data() {
            return {
                show: false,
                inventory:{
                    id:0,
                    amount:0,
                    stock:'-',
                    limit:'-',
                    property:"-"
                }
            }
        },
        methods: {
            preSubmit(){
                let {id,amount} = this.inventory;
                let preBuyParams = {}
                 preBuyParams.goodsid = this.SkuInfo.id
                 preBuyParams.gpid = id
                 preBuyParams.amount = amount
                this.$emit('preBuy',preBuyParams)
            },
            closeSheet() {
                this.$emit('closeSheet', false);
            },
            selectSku(e){
                if(this.SkuInfo.inventory.length==1) return;
                let {id,stock,limit,property} = e;
                Object.assign(this.inventory,{id,stock,limit,property})
            }
        },
        props: {
            SkuInfo: Object,
            skushow: Boolean
        }
    }
</script>
